(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function pushEvent(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    } catch (error) {
      // no-op
    }
  }

  ready(function () {
    var root = document.querySelector('[data-csc-landing]');
    if (!root) return;

    var landingPath = root.getAttribute('data-csc-landing-path') || '/pages/cannabis-social-club-eintragen';
    var loggedIn = root.getAttribute('data-csc-landing-logged-in') === 'true';
    var url = new URL(window.location.href);
    var resume = url.searchParams.get('cs_portal_resume');

    pushEvent('csc_landing_view', {
      landing_path: landingPath,
      logged_in: loggedIn
    });

    if (loggedIn) {
      pushEvent('csc_form_view', {
        landing_path: landingPath,
        source: 'portal_handoff'
      });
    }

    root.querySelectorAll('[data-csc-landing-event]').forEach(function (link) {
      link.addEventListener('click', function () {
        var eventName = link.getAttribute('data-csc-landing-event');
        var location = link.getAttribute('data-csc-landing-location') || '';
        pushEvent(eventName, {
          landing_path: landingPath,
          location: location,
          href: link.getAttribute('href') || '',
          logged_in: loggedIn
        });
      });
    });

    if (resume === '1') {
      window.setTimeout(function () {
        var target = document.getElementById('club-eintragen');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
    }
  });
})();
